// extracted by mini-css-extract-plugin
export default {"card":"HeaderCard_card__zrCaw","img":"HeaderCard_img__-qHkc","cardContainer":"HeaderCard_cardContainer__NzofU","ex":"HeaderCard_ex__bhmAY","title":"HeaderCard_title__iVa0s"};